import type { FormxFieldValueWithSubmission, IFormxRepository } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createListFormxValuesByFieldUseCase({ formxRepository }: Deps) {
  return async function listFormxValuesByField(fieldId: string, limit?: number): Promise<FormxFieldValueWithSubmission[]> {
    return formxRepository.listValuesByField(fieldId, limit);
  };
}
